export const IMAGEM_CARD_TEST_ID_PREFIX = "embarcacao-imagens";
export const IMAGEM_CARD_DOWNLOAD_LABEL = "Download";
export const IMAGEM_CARD_IMAGE_DOWNLOAD_LABEL = "Baixar";
export const IMAGEM_CARD_PRINCIPAL_LABEL = "Principal";
export const IMAGEM_CARD_DOWNLOAD_ERROR_MESSAGE =
  "Não foi possível baixar a imagem. Tente novamente.";
